import { countWords, splitWords } from "../../../Utils";

/**
 * Determine what value a Story Bible textarea should hold after an edit attempt.
 *
 * @param {string} text - The proposed new text (post-edit value from the textarea).
 * @param {string} value - The existing (pre-edit) value stored in state.
 * @param {number|null|undefined} maxWords - Word limit. Null/undefined/0 means no limit.
 * @returns {{ result: string, action: "accepted"|"rejected"|"truncated" }}
 */
export function formatContent(text, value, maxWords) {
  // No limit → always accept
  if (!maxWords || !text) {
    return { result: text, action: "accepted" };
  }

  const newWordCount = countWords(text);

  // Under or at the limit → accept as-is
  if (newWordCount <= maxWords) {
    return { result: text, action: "accepted" };
  }

  // Over the limit: check if the EXISTING value was already over-limit (grandfathered)
  const existingWordCount = countWords(value || "");
  if (existingWordCount >= maxWords) {
    // Reject the edit entirely: preserve the existing value so we don't destroy
    // content that was saved before the limit was introduced.
    return { result: value, action: "rejected" };
  }

  // Existing value was under the limit, new text exceeds it → truncate to maxWords
  const words = text.split(" ");
  const delta = words.length - newWordCount;

  let reassembled = words.slice(0, maxWords + delta).join(" ");
  let reassembledSplit = splitWords(reassembled);

  let i = maxWords + delta;
  while (reassembledSplit.length > maxWords) {
    reassembled = words.slice(0, i).join(" ");
    reassembledSplit = splitWords(reassembled);
    i--;
  }

  return { result: reassembled, action: "truncated" };
}
